module.exports = __webpack_public_path__ + "img/consult_info1.9baa50af.gif";